module.exports = __webpack_public_path__ + "static/media/node.51ef5eb2.jpg";